import type { ServiceDetail } from '../types/content'

export const serviceDetails: ServiceDetail[] = [
  {
    index: '01',
    name: 'Brand & Identity',
    description:
      'A clear system for saying who you are before you say what you sell. We turn founder instinct into a brand your team can use with confidence.',
    deliverables: [
      'Brand strategy workshop',
      'Brand positioning',
      'Naming support',
      'Tone of voice & messaging',
      'Moodboards & art direction',
      'Logo design',
      'Logo suite & variations',
      'Wordmark and monogram',
      'Color systems',
      'Typography systems',
      'Iconography',
      'Illustration direction',
      'Brand guidelines document',
      'Business cards & stationery',
      'Pitch and deck templates',
      'Social media kit',
      'Packaging basics',
      'Rebrands and refreshes',
    ],
    audience: 'Founder-led teams whose visual identity no longer reflects the quality, clarity or ambition of the business.',
    timeline: 'Run on its own · 2–3 weeks',
  },
  {
    index: '02',
    name: 'Website Design',
    description:
      'A site designed around the decisions your customers need to make — from first glance through to a qualified enquiry or purchase.',
    deliverables: [
      'UX research',
      'Competitor audits',
      'User personas',
      'User flows',
      'Information architecture',
      'Sitemaps',
      'Wireframing',
      'Low and high fidelity UI',
      'Responsive and mobile-first design',
      'Landing pages',
      'Marketing sites',
      'E-commerce design',
      'Microcopy and content structure',
      'Motion and microinteractions',
      'Accessibility (WCAG AA)',
      'Design QA',
      'Website redesigns',
    ],
    audience: 'Companies with a real offer and a site that is making people work too hard to understand it.',
    timeline: 'Run on its own · 3–4 weeks',
  },
  {
    index: '03',
    name: 'Product & App Design',
    description:
      'Interfaces that make complex products feel obvious. We map the path, design the system, and pressure-test the moments that usually break.',
    deliverables: [
      'SaaS dashboard design',
      'Mobile app UI (iOS/Android)',
      'Interactive prototypes',
      'Onboarding flows',
      'Empty states and edge cases',
      'Design systems and component libraries',
      'Usability testing',
      'Handoff documentation',
    ],
    audience: 'Product teams that need a coherent experience before engineering effort locks in the wrong one.',
    timeline: 'Run on its own · 3–6 weeks',
  },
  {
    index: '04',
    name: 'Development & Launch',
    description:
      'A considered design is only useful if it ships beautifully. We build fast, flexible sites and hand over a platform your team can run.',
    deliverables: [
      'Webflow builds',
      'Framer builds',
      'WordPress builds',
      'Shopify builds',
      'Next.js builds',
      'CMS setup and training',
      'Third-party integrations',
      'Forms and automations',
      'Analytics and tracking setup',
      'Technical SEO foundation',
      'Core Web Vitals and performance',
      'Cross-browser QA',
      'Domain and hosting setup',
      'Launch management',
    ],
    audience: 'Teams that need a dependable launch partner, not a hand-off file and a list of things to figure out.',
    timeline: 'Run on its own · 2–4 weeks',
  },
  {
    index: '05',
    name: 'Growth & Ongoing',
    description:
      'The useful work after launch: test what matters, keep the site current, and turn what you learn into the next right improvement.',
    deliverables: [
      'Conversion rate optimization',
      'A/B testing',
      'Landing pages for campaigns',
      'Ad creative',
      'Email and newsletter design',
      'Presentation and investor deck design',
      'Monthly design retainers',
      'Website care plans',
      'Content updates',
    ],
    audience: 'Growing teams that want their website treated as an active part of the business, not a finished project.',
    timeline: 'Run on its own · Monthly or quarterly',
  },
]
